export const zyephrMenu = [
  {
    key: 'dashboard',
    title: 'Dashboard',
    route: '/main/dashboard',
    icon: 'dashboard',
    children: [],
  },
  {
    key: 'users',
    title: 'Users',
    route: '/main/users',
    icon: 'user',
    children: [
      {
        key: 'users',
        title: 'Users',
        route: '/main/users/list',
        icon: 'user',
        children: [],
      },
      {
        key: 'delete-request',
        title: 'Delete Requests',
        route: '/main/users/delete-request',
        icon: 'delete',
        children: [],
      },
    ],
  },
  {
    key: 'team',
    title: 'Team Member',
    route: '/main/team-member',
    icon: 'team',
    children: [],
  },
  {
    key: 'user-roles',
    title: 'User and Roles',
    route: '',
    icon: 'lock',
    children: [
      {
        key: 'role-base-access',
        title: 'Role Base Access',
        route: '/main/role-base-access',
        icon: 'lock',
        children: [],
      },
      {
        key: 'assign-list',
        title: 'Assign Role to User',
        route: '/main/assign-list',
        icon: 'lock',
        children: [],
      },
    ],
  },
  {
    key: 'category',
    title: 'Category',
    route: '/main/category',
    icon: 'team',
    children: [],
  },
  {
    key: 'sub-category',
    title: 'Sub Category',
    route: '/main/sub-category',
    icon: 'team',
    children: [],
  },
  {
    key: 'career',
    title: 'Career',
    route: '/main/career',
    icon: 'container',
    children: [],
  },

  {
    key: 'contactUs',
    title: 'Contact Us',
    route: '/main/contact-us',
    icon: 'contacts',
    children: [],
  },
  {
    key: 'banners-and-modules',
    title: 'Banners and Modules',
    route: '/main/banner',
    icon: 'paper-clip',
    children: [
      {
        key: 'banner',
        title: 'Banner',
        route: '/main/banner',
        icon: 'paper-clip',
        children: [],
      },
      {
        key: 'post-pregnancy-banner',
        title: 'Post-Pregnancy-Banner',
        route: '/main/post-pregnancy-banner',
        icon: 'paper-clip',
        children: [],
      },
      {
        key: 'modules',
        title: 'Modules',
        route: '/main/modules',
        icon: 'paper-clip',
        children: [],
      },
      {
        key: 'banner-modules',
        title: 'Banner Modules',
        route: '/main/banner-modules',
        icon: 'paper-clip',
        children: [],
      },
    ],
  },

  {
    key: 'blog',
    title: 'Blog',
    route: '',
    icon: 'book',
    children: [
      {
        key: 'mobile',
        title: 'Mobile',
        route: '/main/blog/mobile',
        children: [],
      },
      {
        key: 'web',
        title: 'Web',
        route: '/main/blog/web',
        children: [],
      },
      {
        key: 'image-gallery',
        title: 'Image Gallery',
        route: '/main/image-gallery',
        icon: 'file-image',
        children: [],
      },
      {
        key: 'goals',
        title: 'Goals',
        route: '/main/goals/list',
        icon: 'file-image',
        children: [],
      },
      {
        key: 'daily-practice',
        title: 'Daily Practice',
        route: '/main/goals/daily-practice-routines',
        icon: 'file-image',
        children: [],
      },
    ],
  },
  {
    key: 'recipe',
    title: 'Recipe',
    route: '/main/recipe',
    icon: 'paper-clip',
    children: [],
  },
  {
    key: 'pregnancy-content',
    title: 'Pregnancy',
    route: '',
    icon: 'paper-clip',
    children: [
      {
        key: 'pregnancy-content',
        title: 'Pregnancy Content',
        route: '/main/pregnancy/pregnancy-content',
        icon: 'paper-clip',
        children: [],
      },
      {
        key: 'pregnancy-stories',
        title: 'Pregnancy Stories',
        route: '/main/pregnancy/pregnancy-stories',
        icon: 'paper-clip',
        children: [],
      },
    ],
  },
  {
    key: 'symptoms',
    title: 'Symptoms & Triggers',
    route: '/main/symptom',
    icon: 'paper-clip',
    children: [
      {
        key: 'menstruation-symptom',
        title: 'Menstruation Symptom',
        route: '/main/menstruation-symptom',
        icon: 'paper-clip',
        children: [],
      },
      {
        key: 'symptom',
        title: 'Symptom',
        route: '/main/symptom',
        icon: 'paper-clip',
        children: [],
      },
      {
        key: 'trigger',
        title: 'Trigger',
        route: '/main/trigger',
        icon: 'paper-clip',
        children: [],
      },
    ],
  },

  {
    key: 'vaccine',
    title: 'Vaccinne Schedule',
    route: '/main/vaccine-schedule',
    icon: 'paper-clip',
    children: [],
  },

  {
    key: 'community',
    title: 'Community',
    route: '/main/community',
    icon: 'comment',
    children: [
      {
        key: 'communityTopic',
        title: 'Community Topic',
        route: '/main/community/community-topic',
        children: [],
      },
      {
        key: 'feed',
        title: 'Feed',
        route: '/main/community/feed',
        children: [],
      },
      {
        key: 'feed-comments',
        title: 'Feed Comments',
        route: '/main/community/feed-comments',
        children: [],
      },
    ],
  },
  {
    key: 'reporting',
    title: 'Reporting',
    route: '/main/reporting',
    icon: 'area-chart',
    children: [
      {
        key: 'userWise',
        title: 'User Wise',
        route: '/main/reporting/user',
        children: [],
      },
      {
        key: 'trafficMonitoring',
        title: 'Traffic Monitoring',
        route: '/main/reporting/traffic-monitoring',
        children: [],
      },
    ],
  },
  {
    key: 'deep-linking',
    title: 'Deep Linking',
    route: '/main/deep-linking',
    icon: 'area-chart',
    children: [
      {
        key: 'campaign',
        title: 'Campaign',
        route: '/main/campaign',
        children: [],
      },
      {
        key: 'deepLinking',
        title: 'Deep Linking',
        route: '/main/deep-linking',
        children: [],
      },
    ],
  },
];
